import { hasCustomRoles } from './hasCustomRoles';
import type { Member } from './types';

export function isAdmin(member: Member) {
  return !hasCustomRoles(member) && member.role === 'admin';
}
